const getContentTypeColors = () => {
  return {
    achievement: '#f78154',
    'calendar-event': '#baa898',
    competency: '#b4dc7f',
    course: '#4d9de0',
    'individual-achievement': '#8d5a97',
    path: '#e15554'
  };
};

export default getContentTypeColors;
